module.exports = __webpack_public_path__ + "img/woman.74231cf6.png";